import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'

import useOsobaData from './hooks/useOsobaData'
import useOsobaModal from './hooks/useOsobaModal'
import SearchActionsBar from '@/widgets/SearchActionsBar'
import LoadMoreSection from '@/widgets/LoadMoreSection'
import OsobaTable from './components/OsobaTable'
import OsobaModal from './components/OsobaModal'
import PlacowkaFilterModal from '@/filter-modals/components/PlacowkaFilterModal'

export default function Osoba() {
	const [searchParams] = useSearchParams()
	const initialPlacowkaId = searchParams.get('id_placowka') || searchParams.get('placowkaId') || null
	const [isPlacowkaFilterOpen, setIsPlacowkaFilterOpen] = useState(false)
	const [selectedPlacowkaId, setSelectedPlacowkaId] = useState(initialPlacowkaId)

	const {
		data,
		loading,
		loadingMore,
		error,
		totalCount,
		hasMore,
		loadData,
		handleLoadMore,
		setSorting,
		updateFilters,
		sortColumn,
		sortDirection,
		searchQuery,
		clearError,
	} = useOsobaData()

	useEffect(() => {
		if (initialPlacowkaId) {
			updateFilters({ id_placowka: initialPlacowkaId })
		}
	}, [initialPlacowkaId, updateFilters])

	const {
		isModalOpen,
		editingItem,
		formImieINazwisko,
		setFormImieINazwisko,
		formFunkcja,
		setFormFunkcja,
		formTelefon,
		setFormTelefon,
		formEmail,
		setFormEmail,
		formPlacowkaId,
		formPlacowkaName,
		isSaving,
		isPlacowkaSelectOpen,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
		openPlacowkaSelectModal,
		closePlacowkaSelectModal,
		applyPlacowkaSelection,
		buttons,
	} = useOsobaModal(loadData)

	useEffect(() => {
		if (error) {
			Swal.fire({
				title: 'Error',
				text: error,
				icon: 'error',
			}).then(() => {
				clearError()
			})
		}
	}, [error, clearError])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleSort = column => {
		const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc'
		setSorting(column, newDirection)
	}

	const handleSearchChange = e => {
		updateFilters({ searchText: e.target.value })
	}

	const handleApplyPlacowkaFilter = placowkaId => {
		updateFilters({ id_placowka: placowkaId || null })
		setSelectedPlacowkaId(placowkaId || null)
		setIsPlacowkaFilterOpen(false)
	}

	return (
		<>
			<div className="flex h-[calc(100dvh-6rem)] flex-col lg:h-[calc(100dvh-2.5rem)]">
				<SearchActionsBar
					value={searchQuery}
					onChange={handleSearchChange}
					placeholder="Szukaj osob po imieniu i nazwisku..."
					buttons={buttons}
				/>

				<OsobaTable
					data={data}
					loading={loading}
					sortColumn={sortColumn}
					sortDirection={sortDirection}
					onSort={handleSort}
					onEdit={openEditModal}
					onDelete={handleDelete}
					hasPlacowkaFilter={!!selectedPlacowkaId}
					onOpenPlacowkaFilter={() => setIsPlacowkaFilterOpen(true)}
				/>

				<LoadMoreSection
					hasMore={hasMore}
					loadingMore={loadingMore}
					onLoadMore={handleLoadMore}
					dataLength={data.length}
					totalCount={totalCount}
				/>
			</div>
			<OsobaModal
				isOpen={isModalOpen}
				editingItem={editingItem}
				formImieINazwisko={formImieINazwisko}
				setFormImieINazwisko={setFormImieINazwisko}
				formFunkcja={formFunkcja}
				setFormFunkcja={setFormFunkcja}
				formTelefon={formTelefon}
				setFormTelefon={setFormTelefon}
				formEmail={formEmail}
				setFormEmail={setFormEmail}
				formPlacowkaId={formPlacowkaId}
				formPlacowkaName={formPlacowkaName}
				onOpenPlacowkaSelect={openPlacowkaSelectModal}
				isSaving={isSaving}
				onClose={closeModal}
				onSubmit={handleSubmit}
			/>
			<PlacowkaFilterModal
				isOpen={isPlacowkaFilterOpen}
				onClose={() => setIsPlacowkaFilterOpen(false)}
				selectedPlacowkaId={selectedPlacowkaId}
				onApply={handleApplyPlacowkaFilter}
			/>
			<PlacowkaFilterModal
				isOpen={isPlacowkaSelectOpen}
				onClose={closePlacowkaSelectModal}
				selectedPlacowkaId={formPlacowkaId}
				onApply={applyPlacowkaSelection}
				title="Wybierz placowke"
				description="Wyszukaj i wybierz placowke dla osoby."
				applyLabel="Wybierz"
				clearLabel="Wyczysc wybor"
			/>
		</>
	)
}
